<template>
    <v-card flat>
        <v-card-text>
            <v-row>
                <v-col cols="12">
                    <v-textarea
                        type="text"
                        v-model="data.office_name"
                        :label="$t('office.office_name')"
                        :error-messages="formError(errors, 'officeName')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        type="text"
                        v-model="data.address"
                        :label="$t('office.address')"
                        :error-messages="formError(errors, 'address')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-autocomplete
                        :items="cantonsItems"
                        :label="$t('office.canton')"
                        v-model="data.canton.code"
                        :error-messages="formError(errors, 'canton')"
                        :hint="$t('general.required')"
                        persistent-hint
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        type="text"
                        v-model="data.zip"
                        :label="$t('office.zip')"
                        :error-messages="formError(errors, 'zip')"
                    />
                </v-col>
                <v-col cols="6">
                    <v-text-field
                        type="text"
                        v-model="data.city"
                        :label="$t('office.city')"
                        :error-messages="formError(errors, 'city')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.office_phone"
                        :label="$t('office.office_phone')"
                        :error-messages="formError(errors, 'officePhone')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-text-field
                        type="text"
                        v-model="data.fax"
                        :label="$t('office.fax')"
                        :error-messages="formError(errors, 'fax')"
                    />
                </v-col>
                <v-col cols="12">
                    <v-textarea
                        type="text"
                        v-model="data.memo"
                        :label="$t('office.memo')"
                        :error-messages="formError(errors, 'memo')"
                    />
                </v-col>
            </v-row>
        </v-card-text>
    </v-card>
</template>

<script>

import { mapGetters } from 'vuex';

export default {
    name: 'OfficeInformation',
    props: {
        data: {
            type: Object,
            default: () => ({
                name: '',
                roles: [],
            }),
        },
        errors: {
            type: Object,
            default: () => ({}),
        },
    },
    computed: {
        ...mapGetters({
            cantons: 'canton/cantons',
        }),
        cantonsItems() {
            const allCantons = [];
            for (let i = 0; i < this.cantons.length; i++) {
                const canton = this.cantons[ i ];
                allCantons.push({
                    value: canton.code,
                    text: `${canton.code} ${canton.name}`,
                })
            }
            return allCantons;
        },
    },
};
</script>
